import { render, staticRenderFns } from "./header-bar.vue?vue&type=template&id=4becd5fc&scoped=true&"
import script from "./header-bar.vue?vue&type=script&lang=js&"
export * from "./header-bar.vue?vue&type=script&lang=js&"
import style0 from "./header-bar.vue?vue&type=style&index=0&id=4becd5fc&lang=scss&scoped=true&"
import style1 from "./header-bar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4becd5fc",
  null
  
)

export default component.exports